// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from "@material-ui/core/Box";
import {Input} from '@mzvonar/modular-redux-form';
import {SHAPES} from '../../../../server/shared/constants/zoneConstants';
import type {Shape as ShapeType, ShapeType as ShapeTypeType} from '../../../types';
import Polygon from './Polygon';
import Circle from './Circle';
import Line from './Line';

export type Props = $ReadOnly<{
    type: ShapeTypeType,
    shape: ShapeType,
    name: string,

    inputChange: (name: string, value: mixed) => void,
    setType: (type: ShapeTypeType) => void,
    setShape: (shape: ShapeType) => void
}>;

function Shape({type, shape, name, inputChange, setType, setShape}: Props) {
    const handleChange = (event, newValue) => {
        setType(newValue);
    };

    const id = `${name}.type`;

    return (
        <React.Fragment>
            <Input
                id={id}
                name={id}
                type="hidden"
                validate={['required']}
                value={type}
            />

            <Tabs
                value={type}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="Zone list type"
            >
                <Tab
                    label={<FormattedMessage
                        id="newZoneForm.shape.type.polygon"
                        defaultMessage="Polygon"
                    />}
                    value="polygon"
                />
                <Tab
                    label={<FormattedMessage
                        id="newZoneForm.shape.type.circle"
                        defaultMessage="Circle"
                    />}
                    value="circle"
                />
                <Tab
                    label={<FormattedMessage
                        id="newZoneForm.shape.type.line"
                        defaultMessage="Line"
                    />}
                    value="line"
                />
            </Tabs>
            <Box mt={2}>
                {type === SHAPES.polygon &&
                    <Polygon
                        name={name}
                        shape={shape}
                        inputChange={inputChange}
                        setShape={setShape}
                    />
                }
                {type === SHAPES.circle &&
                    <Circle
                        name={name}
                        shape={shape}
                        inputChange={inputChange}
                        setShape={setShape}
                    />
                }
                {type === SHAPES.line &&
                    <Line
                        name={name}
                        shape={shape}
                        inputChange={inputChange}
                        setShape={setShape}
                    />
                }
            </Box>
        </React.Fragment>
    );
}

export default Shape